import type { SxProps } from "@mui/material"
import { Box, Collapse, Stack } from "@mui/material"

import { LEFT_DRAWER_COLOR } from "@constants/colors"
import { toNumber } from "@utils/functions/to_number"

export default function PersistDrawer({
  isOpen,
  header,
  children,
  sx,
  containerPadding
}: {
  isOpen: boolean
  header: React.ReactNode
  children: React.ReactNode
  sx?: SxProps
  containerPadding?: number | string
}) {
  return (
    <Collapse orientation="horizontal" in={isOpen}>
      <Stack
        sx={{
          width: "17rem",
          height: "100%",
          background: LEFT_DRAWER_COLOR,
          ...sx
        }}
      >
        <Box sx={{ width: "100%" }}>{header}</Box>
        <Stack
          sx={{
            display: "flex",
            direction: "column",
            flex: 1,
            maxHeight: "100%",
            overflowY: "auto",
            overflowX: "hidden",
            p: toNumber(containerPadding, 1)
          }}
        >
          {children}
        </Stack>
      </Stack>
    </Collapse>
  )
}
